module.exports = __webpack_public_path__ + "static/media/vip_bg_3.c0709b09.png";